<template>
  <div class="home-page">
    <!--    <div @touchend.stop.prevent="hanldeLeave" @touchstart.stop.prevent="handleCount">测试</div>-->
    <!--    {{ count }}-->
    <img class="img-logo" src="@/assets/images/LOGO@3x.png" alt="" @click="showIcon = !showIcon">
    <img class="img-background" src="@/assets/images/background@3x.png" alt="">
    <div class="lead-around">
      <div v-for="(item, idx) of showIcon?buttonList:newButtonList" :key="idx" class="lead-button" @click="handleSkipPageClick(item)">
        <img :src="item.img" alt="">
        <div class="lead-button-font">
          <p>{{ $t(item.button) }}</p>
          <div v-if="item.key === 4&&getHumber !== 0" class="lead-hint">{{ getHumber }}</div>
        </div>
      </div>
    </div>
    <van-popup v-model="show" position="bottom" class="van-popup" round>
      <div class="popup-select" @click="scanQRCode"> 扫描设备码 </div>
      <div class="popup-select" @click="handleCelerityClick"> 直接报修 </div>
    </van-popup>
  </div>
</template>
<script>
import { buttonList, newButtonList } from '@/utils/titleList'
// import axios from 'axios'
export default {
  name: 'HomePage',
  data() {
    return {
      wxBrowser: '', // 判断是否是微信游览器
      show: false, // 选择报修弹出层
      getHumber: 0, // 待评价数量
      buttonList, // 按钮列表
      newButtonList, // 按钮列表（第二套）
      showIcon: true // 两套按钮切换
    }
  },
  mounted() {
    this.handleIsCelerity()
    this.handleGetNumber()
    this.handleWxConfig()
    this.is_wx()
    debugger
  },
  methods: {
    // 扫码报修进保修页面
    handleIsCelerity() {
      const newQuery = JSON.parse(JSON.stringify(this.$route.query))
      if (newQuery.deviceCode) {
        const deviceCodeSession = newQuery.deviceCode
        delete newQuery.deviceCode
        this.$router.replace({ query: newQuery })
        this.$router.push({ path: '/celerityRepairs', query: { deviceCode: deviceCodeSession }})
      }
    },
    /*
      判断是不是在微信内置的游览器中
    */
    is_wx() {
      const en = window.navigator.userAgent.toLowerCase()
      // 匹配en中是否含有MicroMessenger字符串
      // eslint-disable-next-line eqeqeq
      if (en.match(/MicroMessenger/i) == 'micromessenger') {
        // 微信游览器
        this.wxBrowser = true
        return
      }
      // 其他游览器
      this.wxBrowser = false
    },
    /*
      微信授权
    */
    handleWxConfig() {
      if (this.$store.state.isAndroid) {
        this.$api('OTHER_GET_JSSDK', {
          url: window.location.href
        }).then((res) => {
          if (res.code !== 200) return
          const { result } = res
          const timestamp = result.timestamp
          const appId = result.appId
          const nonceStr = result.nonceStr
          const signature = result.signature
          // 微信授权
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: nonceStr, // 必填，生成签名的随机串
            signature: signature, // 必填，签名
            jsApiList: ['startRecord', 'playVoice', 'uploadVoice', 'stopRecord', 'scanQRCode'] // 必填，需要使用的JS接口列表
          })
        })
      }
    },
    /*
    * 微信扫码
    * */
    scanQRCode() {
      if (this.wxBrowser === false) {
        this.$toast('普通游览器不支持扫码报修')
        return
      }
      // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          window.open(res.resultStr)
          // this.$router.push({ path: '/celerityRepairs', query: { code_info: res }})
        }
      })
    },
    /*
    * 直接报修Celerity
    * */
    handleCelerityClick() {
      this.$router.push({ path: '/celerityRepairs', query: { Celerity: 'direct' }})
    },
    /*
    已完成待评价数量
    */
    handleGetNumber() {
      this.$api('REPAIR_COUNT_H5', {}, true).then((res) => {
        if (res.code === 200) {
          this.getHumber = res.result
        } else {
          this.$toast(res.msg)
        }
      })
    },
    // 控制扫码路由路径
    handleSkipPageClick(path) {
      if (path.toPage === '/celerityRepairs') {
        this.show = true
        return
      }
      if (path.toPage) {
        this.$router.push({ path: path.toPage, query: { key: path.key }})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .home-page {
    overflow: auto;
    .van-popup {
      height: 130px;

      .popup-select {
        height: 50%;
        display: flex;
        justify-content: center;
        font-size: 15px;
        align-items: center;
        &:nth-child(1) {
          border-bottom: #F5F5F5 1px solid;
        }
      }
    }
    .img-background {
      width: 100%;
      z-index: -1;
    }
    .img-logo {
      position: absolute;
      width: 170px;
      height: 20px;
      top: 55px;
      left: 13.5px;
    }
    .lead-around {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 0 13.5px;
      background: rgba(255, 255, 255, 0);
      position: absolute;
      top: 117px;
      .lead-hint {
        margin-left: 3.5px;
        display: flex;
        width: 14px;
        height: 14px;
        background-color: red;
        z-index: 999;
        border-radius: 50%;
        color: #ffffff;
        font-size: 12px;
        justify-content: center;
        line-height: 14px;
      }
      .lead-button {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        box-shadow: 0 2px 20px 0 rgba(0,91,172,0.20); ;
        width: 47.33%;
        height: 160px;
        border-radius: 10px;
        background-color: #fff;
        padding: 21px 10px 13.5px 10px;
        margin-bottom: 13.5px;
        img {
          width: 50px;
          height: 50px;
        }
        .lead-button-font {
          align-items: center;
          display: flex;
          margin: 0 6px;
          width: 125px;
          height: 35px;
          padding: 11px 9px;
          border-radius: 5px;
          background-color: rgba(174, 208, 238, 0.4);
          font-size: 14px;
          p {
            color: #005BAC;
            font-weight: Bold;
          }
        }
      }
    }
  }

</style>
